import ProductItems from 'components/ProductItems';
import './styles.scss';
import { Button } from 'components/buttons/Button/Button';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { fetchRelatedProducts, selectRelatedProducts } from 'store/slices/ProductsSlice';
import { useParams } from 'react-router-dom';
import { ROUTES } from 'constants/routes';
// {
//   "data": [
//     {
//       "slug": "related_product_1",
//       "type": "related_product",
//       "preview_title": "Related product 1",
//       "preview_image": "http://54.93.104.183/storage/instagram/instagramImage1.png",
//       "logo": "http://54.93.104.183/storage/products content/product-bottle.jpg",
//       "preview_description": "Preview description Related product 1",
//       "preview_button_text": "Preview button text"
//     }
//   ],
//   "next": true
// }
const RelatedProductsBox = ({ title }) => {
    // get related products
    const dispatch = useDispatch();
    const { slug } = useParams();
    // TODO add pagination
    const { data, next } = useSelector(selectRelatedProducts);

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchRelatedProducts({ slug }));
    }, [dispatch, slug]);

    return (
        <div className="box product-box">
            {title && <h3>{title}</h3>}
            {data?.length > 0 && <ProductItems data={data} baseRoute={ROUTES.products} />}
            {/* <Button type="show-more">SHOW MORE</Button> */}
        </div>
    );
};
export default RelatedProductsBox;
